import React from 'react';
import { topTestimonials } from '../data/testimonials';
import { Stars } from './Stars';
export function TopTestimonials() {
  return <section className="bg-petrol-dark px-4 pb-8 sm:px-6" data-id="element-245" data-mp="1pdhslczvk2n0">
      <div className="mx-auto max-w-6xl" data-id="element-246" data-mp="1ah8vagzjnzd8">
        <p className="text-center font-display text-[9px] font-bold uppercase tracking-[0.16em] text-white/50 sm:text-[10px]" data-id="element-247" data-mp="1agha803kpk17">
          Témoignage d’exemple — à remplacer par un client vérifié
        </p>
        <ul className="mt-3 grid gap-3 sm:grid-cols-3" data-id="element-248" data-mp="11n49ibz9pe4k">
          {topTestimonials.map(item => <li key={item.name} className="flex flex-col rounded-xl bg-white p-4 shadow-sm" data-id="element-249" data-mp="16ggnls6bm2j2">
              <Stars data-id="element-250" data-mp="rs2krh8wme2i" />
              <blockquote className="mt-2 flex-1 text-[13px] italic leading-snug text-graphite sm:text-sm" data-id="element-251" data-mp="roepodnt9jlo">
                « {item.quote} »
              </blockquote>
              <footer className="mt-3" data-id="element-252" data-mp="iq31eiaf2xwe">
                <p className="font-display text-xs font-extrabold uppercase text-petrol" data-id="element-253" data-mp="mr50mz4c39yd">
                  {item.name}
                </p>
                <p className="text-[11px] text-graphite/60" data-id="element-254" data-mp="2dt5t2bnev634">{item.location}</p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}